import * as _ from "lodash";

export const adTagLinker = function(ctrl, $resources) {
  const $state = $resources.$state;

  return function() {
    const tags = _.map(ctrl.bulkSelection, function(tag) {
      return {
        auId: tag.tagId,
        auW: tag.width || _.get(_.get(tag.dimensions || [], 0), 0) || "",
        auH: tag.height || _.get(_.get(tag.dimensions || [], 0), 1) || "",
        auName: tag.name
      };
    });
    $state.go('app.ad-tag', {design: JSON.stringify(tags)});
  };
};
